
const getStyles = (theme) => ({
  firstRow: {
    width: "100%"
  }
});

export default getStyles;